import { HttpInterceptorFn } from '@angular/common/http';

function isCorporateApiRequest(url: string): boolean {
  if (url.startsWith('/api')) {
    return true;
  }

  if (typeof window === 'undefined' || !window.location?.origin) {
    return false;
  }

  try {
    const parsedUrl = new URL(url, window.location.origin);
    return parsedUrl.origin === window.location.origin && parsedUrl.pathname.startsWith('/api');
  } catch {
    return false;
  }
}

function randomHex(length: number): string {
  const bytes = new Uint8Array(length / 2);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}

export function createTraceparent(): string {
  return `00-${randomHex(32)}-${randomHex(16)}-01`;
}

export const traceContextInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isCorporateApiRequest(req.url) || req.headers.has('traceparent')) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        traceparent: createTraceparent(),
      },
    }),
  );
};
